import React from 'react';

interface Props {
  className?: string;
}

const Pin: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 12 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.375 6.125C0.375 4.63316 0.967632 3.20242 2.02252 2.14752C3.07742 1.09263 4.50816 0.5 6 0.5C7.49184 0.5 8.92258 1.09263 9.97748 2.14752C11.0324 3.20242 11.625 4.63316 11.625 6.125C11.625 7.61684 11.0324 9.04758 9.97748 10.1025C8.92258 11.1574 7.49184 11.75 6 11.75C4.50816 11.75 3.07742 11.1574 2.02252 10.1025C0.967632 9.04758 0.375 7.61684 0.375 6.125ZM6 3.625V2.375C3.92969 2.375 2.25 4.05469 2.25 6.125H3.5C3.5 4.74609 4.62109 3.625 6 3.625ZM4.75 19.25V12.8867C5.15625 12.9609 5.57422 13 6 13C6.42578 13 6.84375 12.9609 7.25 12.8867V19.25V20.5H4.75V19.25Z"
      fill="currentColor"
      id="Vector"
    />
  </svg>
);

export default Pin;
